<template>
    <div class="assetAppraiser">
        <div class="condition">
            <div class="item">
                <div class="label">查询:</div>
                <div class="input">
                    <el-input v-model="conditionData.Keyword" size="small" placeholder="请输入"></el-input>
                </div>
            </div>

            <div class="item">
                <div class="label">文件类型:</div>
                <div class="input">
                    <!-- <el-select v-model="conditionData.type" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in typeList"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select> -->
                    <el-input v-model="conditionData.type" size="small" placeholder="请输入"></el-input>
                </div>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="primary" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <el-button type="success" icon="el-icon-circle-plus" size="small" @click="isAddDialog = true">新增</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="580px"
                style="width: 100%">

                <el-table-column
                prop="title"
                label="文件名"
                align="center"
                width="300px"
                >
                </el-table-column>
                <el-table-column
                prop="type"
                label="文件类型"
                align="center"
                width="160px"
                >
                </el-table-column>
                <el-table-column
                prop="description"
                label="文件描述"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-download" size="mini" @click="download(scope.row.fileUrl)">下载文件</el-button>
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="showDeleteDialog(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>

        <el-dialog :visible.sync="isAddDialog" title="新增" width="800px" :close-on-click-modal="false">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        文件类型:
                    </div>
                    <div class="input">
                        <!-- <el-select v-model="addData.type" placeholder="请选择" size="small">
                            <el-option
                            v-for="item in typeList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select> -->
                        <el-input v-model="addData.type" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件名:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.title" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件描述:
                    </div>
                    <div class="textarea">
                        <el-input v-model="addData.description" type="textarea" :rows="2" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件上传:
                    </div>
                    <el-upload
                        action=""
                        multiple
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        :http-request="uploadFile"
                        >
                        <el-button type="primary" size="small" class="uploadbtn">上传图片</el-button>
                    </el-upload>
                    <div class="file">
                        <img class="img" src="../../../assets/images/word.png" @click="download(addData.fileUrl)" v-if="addData.fileUrl"/>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="addZcpgFiles">确认提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="isEditDialog" title="编辑" width="800px" :close-on-click-modal="false">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        文件类型:
                    </div>
                    <div class="input">
                        <!-- <el-select v-model="editData.type" placeholder="请选择" size="small">
                            <el-option
                            v-for="item in typeList"
                            :key="item"
                            :label="item"
                            :value="item">
                            </el-option>
                        </el-select> -->
                        <el-input v-model="editData.type" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件名:
                    </div>
                    <div class="input">
                        <el-input v-model="editData.title" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件描述:
                    </div>
                    <div class="textarea">
                        <el-input v-model="editData.description" type="textarea" :rows="2" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        文件上传:
                    </div>
                    <el-upload
                        action=""
                        multiple
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                        :http-request="uploadFile"
                        >
                        <el-button type="primary" size="small" class="uploadbtn">上传图片</el-button>
                    </el-upload>
                    <div class="file">
                        <img class="img" src="../../../assets/images/word.png" @click="download(editData.fileUrl)" v-if="editData.fileUrl"/>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="updateZcpgFiles">确认提交</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'template',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            tableData:[
                {
                    name:"车损价格评估报告模板",
                    path:"http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220106/20220106112326jcr22/车损价格评估报告模板.docx"
                },
                {
                    name:"简易评估委托书",
                    path:"http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220106/20220106112618syRQW/简易评估委托书.doc"
                },{
                    name:"评估委托合同",
                    path:"http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220106/202201061126376cZ3x/评估委托合同.doc"
                },{
                    name:"机动车辆损失明细单",
                    path:"http://txggpic.oss-cn-shenzhen.aliyuncs.com/20220106/20220106181447FhSMF/机动车辆损失明细单.xlsx"
                }
                
            ],

            conditionData:{
                name:'',
                type:'',
                Keyword:'',
                Page:1,
                PageSize:10,
            },
            isAddDialog:false,
            addData:{
                title:'',
                type:'',
                description:'',
                fileUrl:'',
            },
            isEditDialog:false,
            editData:{
                id:'',
                title:'',
                type:'',
                description:'',
                fileUrl:'',
            },
            totalCount:0,

            // typeList:[
            //     '公估协议',
            //     '现场作业文件',
            //     '公估报告模板',
            // ],
        }

    },
    created(){

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async uploadFile(file) {
            console.log(file);
            let res = await api.uploadOther(file.file,{},file.file.name);
            if(this.isAddDialog){
                this.addData.fileUrl = res
            }else{
                this.editData.fileUrl = res
            }
        },
        showEditDialog(row){
            this.editData = row;
            this.isEditDialog = true;
        },
        showDeleteDialog(row){
            this.$confirm('将删除'+row.title+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteZcpgFiles(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        async deleteZcpgFiles(row){
            let res = await api.deleteZcpgFiles(row.id);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.loadingData();
            }
        },
        async addZcpgFiles(){
            let res = await api.addZcpgFiles(this.addData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.addData = {
                    title:'',
                    type:'',
                    description:'',
                    fileUrl:''
                }
                this.isAddDialog = false;
                this.loadingData();
            }
        },
        async updateZcpgFiles(){
            let res = await api.updateZcpgFiles(this.editData);
            if(res.data.code == '200'){
                this.$message({
                    type: 'success',
                    message: '编辑成功!'
                });
                this.loadingData();
                this.isEditDialog = false;
            }
        },
        async loadingData() {
            let res  = await api.queryFilesList(this.conditionData);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
            
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        reset(){
            this.conditionData = {
                name:'',
                type:'',
                Keyword:'',
                Page:1,
                PageSize:10,
            };
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.Page = page;
            this.loadingData();
        },


        download(fileUrl){
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', fileUrl);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 10px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 5px;
            .label{
                min-width: 110px;
            }
            .input{
                width: 215px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
            /deep/.el-tabs__header{
                margin: 0;
            }
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                width: 100px;
            }
            .value{
                width: 215px;
            }
            .file{
                img{
                    margin-left: 10px;
                    width: 100px;
                    height: 100px;
                }
            }
            .textarea{
                width: 630px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
